import { useContext } from 'react';

import GenericPdfContext from './GenericPdfContext';

const useGenericPdfContext = () => useContext(GenericPdfContext);

export default useGenericPdfContext;
